var page = function(){

    function showPopupTemplate($body){
        console.log("Check need show popup");
        gvf.endpoint(
            "controller\\web\\webController::renderPopUp",
            [],
            function(resp){
                if(resp.status=="ok"){
                    if(resp.html){
                        console.log("Show popup");
                        var $popUpModal = $body.find("#createPopup");
                        var $popUpModalBody = $popUpModal.find("#modalPopupBody");
                        $popUpModalBody.empty();
                        $popUpModalBody.append(resp.html);
                        $popUpModal.modal('show');
                        ui.init($popUpModal);
                    }
                    setTimeout(function(){
                        showPopupTemplate($body);
                    }, 5000);
                }
            }
        );
    }

    function callTimeoutEvent($body,counter){
        if(counter == 1){
            time = 1000;
        }else{
            time = 5000;
        }
        setTimeout(function(){
            gvf.endpoint(
                "controller\\web\\webController::timeoutNavigation",
                [counter],
                function(resp){
                    if(resp.status=="ok"){
                        if(counter<30){
                            if(counter == 1){
                                counter = 0;
                            }
                            callTimeoutEvent($body,counter+5);
                        }
                    }
                }
            );

        }, time);
    }

    ui.readyBody(
        function($body){

            if($body.data("popup-message")){
                Swal.fire({
                    "icon":"info",
                    "html":$body.data("popup-message")
                });
            }

            $body.find("a[href$='#blank']").click(
                function(ev){
                    ev.preventDefault();
                    window.open($(this).attr("href"));
                }
            ).each(
                function(){
                    var href = $(this).attr("href");
                    $(this).attr("href",href.replace("#blank",""));
                }
            );

            showPopupTemplate($body);

            callTimeoutEvent($body,1);
        }
    );
    return {
        "callTimeoutEvent":callTimeoutEvent
    }
}();
